<template>
  <v-app>
    <v-main fluid fill-height>
      <slot />
    </v-main>
    <voeter :showLegal="false" />
  </v-app>
</template>

<script>
import Footer from "@/components/Footer";

export default {
  name: "WebsiteLayout",
  data: () => ({
    // drawer: false,
  }),

  created() {
    // this.$vuetify.theme.light = true;
  },
  components: {
    voeter: Footer, //footer is reserved, using something else
  },
};
</script>
